const ESG_SECTION_DESCRIPTION = `This section delivers a high-level view of your suppliers’ self-reported data relating to Environmental, Social and Governance`;

export default ESG_SECTION_DESCRIPTION;
